import React from "react";
import Layout from "../../../Components/Layouts/Layout";
import Media from "../../../Components/Media";

import "swiper/css";

const ContactDetails = (props) => {
  return (
    <section className="py-20">
      <Layout className="flex-col items-center">
        <div className="text-center md:w-1/2">
          <h1 className="text-2xl md:text-3xl lg:text-5xl mb-5">
            {props.careerDetails.tagLine}
          </h1>
          <p className="md:text-lg mt-3 text-[#505050]">
            {props.careerDetails.tagDescription}
          </p>
        </div>
        <Media
          image={
            process.env.REACT_APP_IMAGE_BASE_URL + props.careerDetails.image
          }
        >
          <div className="text-center md:pr-24">
            <p className="md:text-lg mt-3 text-[#505050]">
              {props.careerDetails.careerText}
            </p>
          </div>
        </Media>
      </Layout>
    </section>
  );
};

export default ContactDetails;
